import React, { useEffect } from "react";
import BookmarkDetailPageSidebar from "./bookmark-detail-page-sidebar";
import { Icons } from "atoms/constants/icons";
import useBookmarksByPublicationQuery from "utilities/hooks/queries/my-link/bookmarks/sidebars/use-bookmarks-by-publication-query";
import SortBy from "../../options/sort-by";
import useSortBookmarks from "utilities/hooks/domain/my-link/use-sort-bookmarks";
import useSearchBookmarks from "utilities/hooks/domain/my-link/use-search-bookmarks";
import SearchBookmarks from "../../options/search-bookmarks";
import usePagedResultsFromParams from "utilities/hooks/use-paged-results-from-params";
import { useParams } from "react-router";
import { BookmarkPaginationSettings } from "constants/bookmark-pagination-constants";
import { BookmarkUtils } from "utilities/bookmark-utils";
import { UserBookmarkCountBy } from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-by";
import FilterByShareStatus from "../../options/filter-by-share-status";
import useFilterBookmarks from "utilities/hooks/domain/my-link/use-filter-bookmarks";
import UserBookmarkShareFilterOption from "models/enumerations/filtering/user-bookmarks/user-bookmark-share-filter-option";

const SidebarForPublications = () => {
    const { groupId } = useParams<{ groupId: string; id: string }>();

    const { sortBy, onSortByChange } = useSortBookmarks(
        UserBookmarkCountBy.Publication
    );
    const { searchText, onSearchTextChange } = useSearchBookmarks(
        BookmarkUtils.buildGroupedParam(
            UserBookmarkCountBy.Publication,
            groupId
        )
    );
    const { onShareFilterChange, shareFilter } = useFilterBookmarks(
        UserBookmarkCountBy.Publication
    );
    const { skip, take, onSetPage, currentPage, numberOfPages, setRowCount } =
        usePagedResultsFromParams(
            BookmarkPaginationSettings.SidebarTake,
            BookmarkUtils.buildGroupedParam(
                UserBookmarkCountBy.Publication,
                groupId
            )
        );

    const { bookmarks, publication } = useBookmarksByPublicationQuery({
        searchText,
        skip,
        take,
        sortBy,
        currentUserOnly:
            shareFilter === UserBookmarkShareFilterOption.PrivateOnly,
    });

    useEffect(() => {
        if (bookmarks?.bookmarksLength) {
            setRowCount(bookmarks?.bookmarksLength);
        }
    }, [bookmarks?.bookmarksLength, setRowCount]);

    return (
        <BookmarkDetailPageSidebar
            totalPages={numberOfPages}
            onSetPage={onSetPage}
            currentPage={currentPage}
            bookmarks={bookmarks?.bookmarks}
            headingText={publication?.getDisplayCodeAndTitle() ?? ""}
            headingIcon={Icons.Book}
            dropdowns={
                <>
                    <FilterByShareStatus
                        shareStatus={shareFilter}
                        onChange={onShareFilterChange}
                    />
                    <SortBy
                        sort={sortBy}
                        onChange={onSortByChange}
                        showBookOrder
                    />
                    <SearchBookmarks
                        searchText={searchText}
                        onChange={onSearchTextChange}
                    />
                </>
            }
        />
    );
};
export default SidebarForPublications;
